import type { Shipping } from '@/domain';
import { formatDay, formatInstant } from '@/shared/format/instant';
import { strings } from '@/shared/strings';
import { collectedAgo, daysSince } from './shippingLabels';
import styles from './ShippingDates.module.css';

/**
 * The shipping dates, on the row rather than inside a dialog. Section 7.2 of
 * the request of 13 September 2026.
 *
 * When it left, when it arrived, and, for a case still waiting for its waybill
 * code, how long it has been waiting. That last figure is the one that tells
 * the desk when to telephone the courier, and it was only ever visible by
 * opening the case.
 */
export function ShippingDates({
  dispatch,
  now = new Date().toISOString(),
}: {
  dispatch: Pick<Shipping, 'status' | 'dispatchedAt' | 'deliveredAt'>;
  now?: string;
}) {
  if (dispatch.dispatchedAt === null) return null;

  return (
    <span className={styles.dates}>
      <span>
        {strings.shipping.dispatchedAt} {formatInstant(dispatch.dispatchedAt)}
      </span>
      {dispatch.status === 'awaiting_tracking' && (
        <span className={styles.waiting}>
          {strings.shipping.collected} {collectedAgo(daysSince(dispatch.dispatchedAt, now))}
        </span>
      )}
      {dispatch.deliveredAt !== null && (
        <span>
          {strings.shipping.receivedAt} {formatDay(dispatch.deliveredAt)}
        </span>
      )}
    </span>
  );
}
